export * from './donate-banner.component';
export * from './donate-form.component';



// WEBPACK FOOTER //
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/main/donate/components/index.ts